import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

var NavTab =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(NavTab, _PureComponent);

  function NavTab() {
    _classCallCheck(this, NavTab);

    return _possibleConstructorReturn(this, _getPrototypeOf(NavTab).apply(this, arguments));
  }

  _createClass(NavTab, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          vertical = _this$props.vertical,
          rest = _objectWithoutProperties(_this$props, ["children", "className", "vertical"]);

      var fullClassName = classNames('nav nav-tabs', className, {
        'nav-stacked': vertical
      });
      return React.createElement("ul", _extends({
        className: fullClassName
      }, rest), children);
    }
  }]);

  return NavTab;
}(PureComponent);

export { NavTab as default };
NavTab.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  vertical: PropTypes.bool
};